import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { TokenHttp } from '../services/tokenhttp.service';
import { BaseRepository } from './base.repository';
import { IPickup, IPickupChange } from '../interfaces/IPickup';


@Injectable()
export class PickupRepository extends BaseRepository {

    constructor(tokenHttp: TokenHttp) { 
        super(tokenHttp);
    }

    public getById(id: string): Observable<IPickup> {
        return this.mapGet("tours/plantToDepot/" + id + "/pickup/info");
    }

    public change(id: string, change: IPickupChange): Observable<IPickup> {
        return this.mapPut("tours/plantToDepot/" + id + "/pickup/change", change);
    }



}